<template>
    <div>
        <EncabezadoCard
                :titulo="'Iniciar Sesión'"
                :sub-titulo="'Cambiar password'"
                :icono="'mdi-lock-reset'"
                style="background-color: #FAFAFA"
        ></EncabezadoCard>

        <v-form @submit.prevent="cambiarPassword" ref="form" v-model="valid"
                lazy-validation>
            <v-card-text>
                <v-container>

                    <v-row>
                        <v-col cols="12" xs="12" class="text-center">
                            <div class="headline mb-1">{{miusuario.nombre}}</div>

                            <v-list-item-title class="title mb-1 ">{{miusuario.cuenta}}</v-list-item-title>
                            <div class="title mb-1 error white--text"> Antes de continuar, primero cambie su
                                password por seguridad
                            </div>
                        </v-col>


                        <v-col cols="8" sm="12" md="12">
                            <v-text-field
                                    v-model="item.password"
                                    id="nuevo_password"
                                    label="Nuevo Password (*)"
                                    :append-icon="mostrarPass1 ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="() => (mostrarPass1 = !mostrarPass1)"
                                    :type="mostrarPass1 ? 'password' : 'text'"
                                    required
                                    :counter="20"
                                    maxlength="20"
                                    autocomplete="off"
                                    :rules="[v => !!v || 'Password es requerido',
                                                           v => (v && v.length <= 20 && v.length>=6) || 'El Password debe ser de 6 a 20 caracteres']"
                            />
                        </v-col>

                        <v-col cols="8" sm="12" md="12">
                            <v-text-field
                                    v-model="item.password_confirmation"
                                    label="Repita Password (*)"
                                    :append-icon="mostrarPass2 ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="() => (mostrarPass2 = !mostrarPass2)"
                                    :type="mostrarPass2 ? 'password' : 'text'"
                                    required
                                    :counter="20"
                                    maxlength="20"
                                    autocomplete="off"
                                    :rules="[v => !!v || 'Password es requerido',
                                                           v => (v && v.length <= 20 && v.length>=6) || 'El Password debe ser de 6 a 20 caracteres']"
                            />
                        </v-col>
                    </v-row>

                </v-container>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="button" class="default" @click="vaciar">
                    <v-icon left>mdi-arrow-left-bold</v-icon>
                    Volver
                </v-btn>
                <v-btn type="submit" color="primary" class="pl-4 pr-4" :disabled="loading"> Ingresar
                    <v-progress-circular
                            v-if="loading"
                            indeterminate
                            color="primary"
                            style="margin-left: 10px"
                    ></v-progress-circular>
                    <v-icon left>mdi-arrow-right-bold</v-icon>

                </v-btn>

            </v-card-actions>
        </v-form>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import EncabezadoCard from "../../components/EncabezadoCard";

    export default {
        name: "loginCambiarPassword",
        components: {EncabezadoCard},
        props: ['miusuario', 'userToken', 'old_password'],

        data: () => ({
            loading: false,
            valid: false,
            mostrarPass1: String,
            mostrarPass2: String,
            item: {},
        }),
        mounted(){
            document.getElementById("nuevo_password").focus();
        },
        methods: {
            vaciar(){
                this.$emit('setMiUsuario', '');
            },
            cambiarPassword() {
                if (!this.$refs.form.validate()) {
                    return;
                }

                this.loading = true;
                let config = {
                    headers: {'Authorization': 'Bearer ' + this.userToken.token.access_token}
                };
                this.item.old_password=this.old_password;

                this.axios.post(
                    this.url_base + "cambiar_password/" + this.userToken.usuario.id,
                    this.item,
                    config
                ).then(response => {
                    if (response.data.res) {

                        //volviendo a autenticar
                        this.$store.dispatch("getToken", {
                            "email": this.userToken.usuario.email,
                            "password": this.item.password
                        }).then(response => {
                            if (response.data.res) {
                                this.loading = false;
                                this.$router.push({name: "Home"});
                            } else {
                                this.loading = false;
                                this.$toastr.error(response.data.message);
                            }
                        }).catch(e => {
                            this.loading = false;
                            this.$toastr.error(this.$funciones.listaErrores(e.response.data.errors));
                        });

                    } else {
                        this.$toastr.error(response.data.message);
                    }
                }).catch(e => {
                    this.loading = false;
                    this.$toastr.error(this.$funciones.listaErrores(e.response.data.errors));
                })
            }
        },
        computed: {
            ...
                mapState(['url_base', 'token'])
        }
    }
</script>

<style scoped>

</style>